const infoCards = [
  {
    icon: 'ri-map-pin-2-fill',
    title: 'Dirección',
    lines: ['Calle Natalio Rivas', '04770 Adra, Almería', 'España'],
    action: {
      label: 'Cómo llegar',
      href: 'https://www.google.com/maps/search/Daro+Tattoo+Adra+Almeria',
      icon: 'ri-route-line'
    }
  },
  {
    icon: 'ri-whatsapp-fill',
    title: 'WhatsApp',
    lines: ['+34 658 402 605', 'Respuesta rápida', 'Consultas y presupuestos'],
    action: {
      label: 'Escribir por WhatsApp',
      href: 'https://wa.me/34658402605?text=%C2%A1Hola!%20Quiero%20hacer%20una%20consulta%20sobre%20vuestros%20servicios%20de%20tatuaje%20%F0%9F%92%AC',
      icon: 'ri-whatsapp-line'
    }
  },
  {
    icon: 'ri-phone-fill',
    title: 'Teléfono',
    lines: ['+34 658 402 605', 'Llamadas directas', 'Lun - Sáb: 10:00 - 20:00'],
    action: {
      label: 'Llamar ahora',
      href: 'tel:+34658402605',
      icon: 'ri-phone-line'
    }
  },
  {
    icon: 'ri-instagram-fill',
    title: 'Redes Sociales',
    lines: ['@Daro_tattoo_', 'Síguenos para ver', 'nuestros últimos trabajos'],
    action: {
      label: 'Ver Instagram',
      href: 'https://www.instagram.com/Daro_tattoo_',
      icon: 'ri-instagram-line'
    }
  }
];

export default function ContactInfo() {
  return (
    <section className="py-16 md:py-20 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {infoCards.map((card) => (
            <div
              key={card.title}
              className="bg-neutral-800/60 border border-neutral-700/50 rounded-lg p-6 hover:border-amber-500/30 transition-all group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-600/15 rounded-lg mb-5 group-hover:bg-amber-600/25 transition-colors">
                <i className={`${card.icon} text-amber-500 text-xl`}></i>
              </div>
              <h3
                className="text-lg font-bold text-white mb-3"
                style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}
              >
                {card.title}
              </h3>
              <div className="space-y-1 mb-5">
                {card.lines.map((line, i) => (
                  <p key={i} className="text-neutral-400 text-sm">{line}</p>
                ))}
              </div>
              <a
                href={card.action.href}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 text-amber-500 text-sm font-medium hover:text-amber-400 transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={card.action.icon}></i>
                </div>
                {card.action.label}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
